export const backendAPI = "https://ancient-journey-49814.herokuapp.com";

//dev api
// export const backendAPI = "http://localhost:5000";
